import React from 'react'
import './WinnersHome.css'
import img1 from '../../Images/Frame 1991425481.png'
import img2 from '../../Images/Frame 1991425472.png'
import img3 from '../../Images/Frame 1991425473.png'
import img4 from '../../Images/Frame 1991425481.png'
import component1 from '../../Images/Component 5.png'
import component2 from '../../Images/Component 7.png'
import component3 from '../../Images/Component 6.png'
import component4 from '../../Images/Component 8.png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const Apartments = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
  autoplaySpeed: 1500,
  pauseOnHover: true,
   responsive: [
      {
        breakpoint: 1199, 
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 699, 
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 499, 
        settings: {
          slidesToShow: 1,
        },
      },
      
    ],
  };
  return (
    <>
    <div className='apartments_div_wrapper'>
    <div className='apartments_div'>
     <h1 className='prefered_cities_head'>Apartments, Villas and more</h1>
     <div 
     className='mt-4'
    //  '
    //  apartments_wrapper
    //  '

     >
     <Slider {...settings}>
     {[component1,component2,component3,component4].map((e,i)=>{
        return(
            <>
            <div className='apartment' key={i}>
                <img src={e}></img>
            </div>
            </>
        )
     })}
     </Slider>

       
     </div>
     </div> 
    </div>

    </>
  )
}

export default Apartments
